import React from 'react';
import Login from './Login';
import Layout from '../common/SimpleLayout';

export default function () {
    return <Layout>
        <Login />
    </Layout>
};